import { jsx as e, Fragment as m, jsxs as p } from "react/jsx-runtime";
import { useState as l } from "react";
import { Badge as f, IconButton as y, Menu as b, MenuList as B, MenuItem as I, ListItemIcon as L, Typography as M } from "@mui/material";
import { useNavigate as q } from "react-router-dom";
import { B as v } from "../../index-BcZ70a8s.js";
import { O as d, l as h, m as k } from "../../index-DVHhaa_b.js";
const w = ({ ...a }) => {
  const [c, i] = l(null), [r, t] = l(!!c), { settings: o } = d(), u = (s) => {
    i(s.currentTarget), t(!0);
  };
  return !o || !o.quickActionList || o.quickActionList.length === 0 ? null : /* @__PURE__ */ e(m, { children: /* @__PURE__ */ p(f, { overlap: "circular", anchorOrigin: { vertical: "bottom" }, ...a, children: [
    /* @__PURE__ */ e(y, { disableFocusRipple: !0, "aria-label": "quickactions", variant: "background", onClick: u, children: /* @__PURE__ */ e(h, { iconType: k.QuickAction }) }),
    /* @__PURE__ */ e(T, { anchorEl: c, open: r, onClose: () => t(!1) })
  ] }) });
}, T = ({ anchorEl: a, open: c, onClose: i, anchorOrigin: r, transformOrigin: t }) => {
  const o = q(), { settings: u } = d();
  if (!u) return null;
  const s = u.quickActionList || [], g = async (n) => {
    i(), n.includes("http") ? await v.open({ url: n }) : o(n);
  };
  return /* @__PURE__ */ e(m, { children: /* @__PURE__ */ e(b, { anchorEl: a, open: !!c, id: "messaging-menu", onClose: i, ...r ? { anchorOrigin: r } : {}, ...t ? { transformOrigin: t } : {}, children: /* @__PURE__ */ e(B, { children: s.map((n, A) => /* @__PURE__ */ p(I, { ...n.Route ? { onClick: () => g(n.Route) } : {}, children: [
    /* @__PURE__ */ e(L, { children: /* @__PURE__ */ e(h, { fontSize: "small", iconType: k[n.IconName] }) }),
    /* @__PURE__ */ e(M, { variant: "body2", noWrap: !0, children: n.Label })
  ] }, n.Route || n.Label || `item-${A}`)) }) }) });
};
export {
  w as QuickActionButton,
  T as QuickActionMenu
};
//# sourceMappingURL=index.js.map
